<template>
    <div class="rural hml_whplt">
        <swiperList :swiperStyle="{padding: '1.29rem .4rem .5rem'}" :setSwiperNumFlag="true">
            <li
            class="ruralSlide"
            v-for="(item,index) in allData[firstLevelIndex].dataArr[secondLevelIndex].list"
            :key="index"
            @click="ruralSlideClick(index)"
            >
                <img :src="item.thumb">
                <div class="textContent hml_whplt">
                    <h2 class="title">{{ item.title }}</h2>
                    <div class="xian"></div>
                    <ul class="keywordsList">
                        <!-- <li>{{ item.keywords }}</li> -->
                        <li
                        v-for="(value,ind) in item.keywords.split('|')"
                        :key="ind"
                        >
                            {{value }}&nbsp;{{ ind == item.keywords.split('|').length - 1?'':'|&nbsp;' }} 
                        </li>
                    </ul>
                </div>
            </li>
        </swiperList>
    </div>
</template>

<script>

import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {

        }
    },
    methods: {
        ruralSlideClick(index){
            this.setIndex({levelThreeIndex: index});
            this.$router.push("/panorama");
        },
        ...publicData.mapMutations(["setIndex"])
    },
    computed: {
        ...publicData.mapState(['allData','firstLevelIndex','secondLevelIndex','levelThreeIndex'])
    }
}
</script>

<style lang="scss" scoped>
.rural{
    // padding-top: .92rem;
    .ruralSlide{
        width: 100%;
        height: 2.4rem;
        position: relative;
        overflow: hidden;
        border-radius: .1rem;
        box-shadow:0px .13rem .27rem 0px rgba(0, 0, 0, 0.24);
        margin-bottom: .24rem;
        .textContent{
            background: linear-gradient(to right,rgba(0,0,0,.6),rgba(0,0,0,0)); /* 标准语法 */
            padding-left: .42rem;
            padding-top: .67rem;
            h2{
                font-size: .5rem;
                color: #fff;
                font-family: "siyuan";
            }
            .xian{
                width: 3.6rem;
                height: 1px;
                background: #fff;
                margin: .16rem 0;
            }
            .keywordsList{
                display: flex;
                align-items: center;
                margin-top: .2rem;
                li{
                    font-size: .22rem;
                    color: #fff;
                }
            }
        }
    }
}
</style>